var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-853.000000, -1375.000000) translate(736.000000, 1376.000000) translate(118.000000, 0.000000)",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    strokeLinejoin: "round",
    cx: 34.308,
    cy: 34.308,
    r: 34.308
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.692000909,12 L0.692000909,37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,0 L0.5,1.61473831"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d55b186a44932aba009ae2a6df38cd79.svg";
export { ForwardRef as ReactComponent };